import getMetaValue from '@Utils/GetMetaValue'

export default function submitGoogleOauthForm() {
  const searchParams = new URLSearchParams(location.search)
  const anonymousId = searchParams.get('anonymous_id')
  const csrfToken = getMetaValue('csrf-token')
  const form = document.createElement('form')
  const oauthRequestPath = '/users/auth/google_oauth2'

  form.method = 'post'
  form.action = anonymousId
    ? `${oauthRequestPath}?${new URLSearchParams({ anonymous_id: anonymousId })}`
    : oauthRequestPath

  if (csrfToken) {
    const csrfInput = document.createElement('input')
    csrfInput.type = 'hidden'
    csrfInput.name = 'authenticity_token'
    csrfInput.value = csrfToken
    form.appendChild(csrfInput)
  }

  document.body.appendChild(form)
  form.submit()
}
